
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";


// Route components
import ExternalRoute from './routes/ExternalRoute';
import PrivateRoute from './routes/PrivateRoute';

import App from './App';
import {AppHeaderContainer} from './components/common/AppHeader';
import {AppMsAuth} from './components/common/AppMsAuth';
import AppExt from './components/common/AppExt';

import {DashboardContainer} from './components/views/dashboard/Dashboard';
import {DiamondsContainer} from './components/views/diamonds/Diamonds';
import {SingleLabDiamondContainer} from './components/views/single-diamond/SingleLabDiamond';
import {WatchesContainer} from './components/views/watches/Watches';
import {SingleOnlineDiamondContainer} from './components/views/single-diamond/SingleOnlineDiamond';
import {SingleRapnetDiamondContainer} from './components/views/single-diamond/SingleRapnetDiamond';
import {SingleDiamondContainer} from './components/views/single-diamond/SingleDiamond';
import {SingleWatchContainer} from './components/views/single-diamond/SingleWatch';
import {ResultsContainer} from './components/views/results/Results';
import {WatchResultsContainer} from './components/views/results/WatchResults';
import {CustomerProfileContainer} from './components/views/customer-profile/CustomerProfile';
import {TransferHistoryContainer} from './components/views/transfer-history/TransferHistory';
import {FinancePlansContainer} from './components/views/finance/FinancePlans';
import {FinanceCalculatorContainer} from './components/views/finance/FinanceCalculator';

import {JewelrySearchContainer} from './components/views/jewelry/JewelrySearch';
import {JewelryResultsContainer} from './components/views/results/JewelryResults';
import {SingleJewelryContainer} from './components/views/single-diamond/SingleJewelry';

import {ManageUsersContainer} from './components/views/manage-users/ManageUsers';
import {MessagesContainer} from './components/views/messages/Messages';

import {LoginContainer} from './components/views/login/Login';
import {ProfileLoading} from './components/views/login/LoginRedirect';
import {InternalResetPasswordContainer} from './components/views/reset-password/InternalResetPassword';
import {ListLeadsContainer} from './components/views/leads/ListLeads';
import {SingleLeadContainer} from './components/views/leads/SingleLead';
import {ExternalCardContainer} from './components/views/external-share/ExternalCard';
import {ExternalWatchContainer} from './components/views/external-share/ExternalWatch';
import {SocialCardContainer} from './components/views/external-share/SocialCard';

import configureStore, { history } from './store';

require('./styles/main.scss');

const store = configureStore();

const msalInstance = new PublicClientApplication(msalConfig);

// function requireAuth(nextState, replaceState, cb) {
//   if(!isLoggedIn()) {
//     replaceState({ pathname: '/login' });
//   }
//   cb();
// }

// function requireNoAuth(nextState, replaceState, cb) {
//   if(isLoggedIn()) {
//     replaceState({ pathname: '/diamonds' });
//   }
//   cb();
// }

// let isStaging = api.IS_STAGING;
const isGallery = false;
if(isGallery) {
  // ReactDOM.render(
  //   <Provider store={store}>
  //     <Router onUpdate={() => window.scroll(0, 0)} history={history}>
  //       <Route path='/' component={AppContainer}>
          
  //           <Route>
  //             <Route path='my-collection/:shareId' component={ExternalCardContainer} />
  //             <Route path='my-timepiece-collection/:shareId' component={ExternalWatchContainer} />
  //             <Route path='shared-collection/:cardId' component={SocialCardContainer} />
  //           </Route>

  //           <Route component={AppExt} onEnter={requireNoAuth}>
  //             <IndexRoute component={Redirect404} />
  //             <Route path='reset-password/:token' component={ResetPasswordContainer} />
  //           </Route>

  //       </Route>
  //     </Router>
  //   </Provider>,
  //   document.getElementById('ddinv-app')
  // );
} else {

  const container = document.getElementById('ddinv-app');
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <Suspense fallback="...">
          <HistoryRouter history={history}>
            <Routes>
              <Route path="/" element={<App />}>

                {/* No header, no auth*/}
                <Route index element={<DashboardContainer />} />
                <Route path='my-collection/:shareId' element={<ExternalCardContainer />} />
                <Route path='my-timepiece-collection/:shareId' element={<ExternalWatchContainer />} />
                <Route path='shared-collection/:cardId' element={<SocialCardContainer />} />

                <Route element={<AppHeaderContainer />}>

                  <Route path='update-password' element={<InternalResetPasswordContainer />} />
                  <Route path='update-security' element={<InternalResetPasswordContainer />} />
                  <Route path='ms-sso' element={<ProfileLoading />} />

                  {/* Header, no auth*/}
                  <Route element={<ExternalRoute />}>
                    <Route element={<AppExt />}>
                      <Route path='login' element={<LoginContainer />} />
                    </Route>
                  </Route>

                  {/* Header, auth*/}
                  <Route element={<PrivateRoute />}>
                    <Route element={<AppMsAuth />}>
                      <Route path='manage-users' element={<ManageUsersContainer />} />
                      <Route path='messages' element={<MessagesContainer />} />
                      
                      <Route path='finance/plans' element={<FinancePlansContainer />} />
                      <Route path='finance/calculator' element={<FinanceCalculatorContainer />} />
                      <Route path='transfer-history' element={<TransferHistoryContainer />} />
                      <Route path='leads' element={<ListLeadsContainer />} />
                      <Route path='customer/view' element={<SingleLeadContainer />} />
                      <Route path='customer/view/:cardId' element={<SingleLeadContainer />} />
                      <Route path='diamonds' element={<DiamondsContainer />} />
                      <Route path='diamond/online/:diamondId' element={<SingleOnlineDiamondContainer />} />
                      <Route path='diamond/rapnet/:diamondId' element={<SingleRapnetDiamondContainer />} />
                      <Route path='diamond/lcd/:diamondId' element={<SingleLabDiamondContainer />} />
                      <Route path='diamond/view/:diamondId' element={<SingleDiamondContainer />} />
                      <Route path='results' element={<ResultsContainer />} />
                      <Route path='customer-profile' element={<CustomerProfileContainer />} />
                      <Route path='watches' element={<WatchesContainer />} />
                      <Route path='watches/results' element={<WatchResultsContainer />} />
                      <Route path='watches/view/:sku' element={<SingleWatchContainer />} />
                      <Route path='jewelry/results' element={<JewelryResultsContainer />} />
                      <Route path='jewelry/view/:sku' element={<SingleJewelryContainer />} />
                      <Route path='jewelry' element={<JewelrySearchContainer />} />
                    </Route>
                  </Route>

                </Route>

              </Route>
            </Routes>
          </HistoryRouter>
        </Suspense>
      </MsalProvider>
    </Provider>
  );
}










































